<template>
  <div class="weather">
    <ep-title style="margin-bottom:30px" title="突发环境事件应急预案">
    </ep-title>
    <div class="header" style="margin-bottom:20px">备案流程</div>
    <ep-steps style="margin-bottom:20px">
      <ep-step step="1" icon="icon-shangbaodanwei">选择上报单位</ep-step>
      <ep-step step="2" icon="icon-yuanxinxi">填写预案信息</ep-step>
      <ep-step step="3" icon="icon-shangchuan">上传备案文件</ep-step>
      <ep-step step="4" icon="icon-shenhe">审核</ep-step>
      <ep-step step="5" icon="icon-wancheng">备案成功</ep-step>
    </ep-steps>
      <el-button type="primary" @click="comfirmButtype">进入备案 </el-button>
    <div class="header header-top" style="margin-bottom:20px">备案规定</div>
    <el-table :data="fileList" border style="width: 100%;margin-bottom:30px">
      <el-table-column prop="fileDes" header-align="center" align="center" label="文件">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="下载" width="180">
        <template slot-scope="scope">
           <img src="./../../../static/img/xz.png" height="16" width="16" @click="getFile(scope.row.id)">
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import weather from '../../data/emer/weather.js'
export default {
  data() {
    return {
      fileList: [],
      type: '',
      fileName: ''
    }
  },
  created() {
    this.get_fileList()
  },
  methods: {
    // 获取突发文件列表
    get_fileList() {
      (async() => {
        let fileState = await weather.guidance_list({
          categories: '3'
        })
        if (fileState) {
          this.fileList = fileState.data
        }
      })()
    },
    comfirmButtype() {
       sessionStorage.typeNum = 0
       if(sessionStorage.itemName == 0) {
       this.$router.push('/Home')
       return
      }
      this.$router.push('/Filedwedd')
    },
    // 突发文件下载
    getFile(val) {
      if (!val) {
        this.$message.warning('文件获取失败,请稍后重试')
        return
      }
      window.location.href = `/api/emer/file/guidance/download?id=${val}`
    }
  }
}

</script>
<style lang="stylus" scoped>
.weather {
  width: 100%;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  .header {
    // width
  }
  a {
    color: #1f2d3d;
    &:hover {
      color: #359eff;
    }
  }
  .header-top{
    margin-top:30px;
  }
}

</style>



// WEBPACK FOOTER //
// Burstplan.vue?0bc69366